// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"a6d3921d","762":"9f9fbb1e"}[chunkId] + ".chunk.js";
};